import { Box } from '@mui/material';
import Logo from '../../components/Login/Logo';
import ResetPasswordComponent from '../../components/ResetPassword/ResetPassword';

function ResetPassword() {
  return (
    <Box className='auth-page'>
      <Box className='center'>
        <Box className='body'>
          <Logo />
          <Box className='login-title-block' mt={2}>
            <Box className='login'>RESET PASSWORD</Box>
          </Box>
          <ResetPasswordComponent />
        </Box>
      </Box>
    </Box>
  );
}

export default ResetPassword;
